<template>
	<modal-wrapper :modalId="modalId" :modalTitle="modalTitle" modalDialogClass="modal-lg" @close="closeForm">
		<div class="modal-body">
            <div class="mb-3 row">
                <label for="recipient_id" class="col-sm-3 col-form-label">Contact<span class="text-danger font-weight-bold">*</span></label>

                <div class="col-md-9">
                    <select v-model="formData.recipient" class="form-select" @change="getChannels">
                        <option :value="'participant_'+participant.id">{{ participant.full_name }} (Participant)</option>
                        <option v-for="contact in contacts" :value="'contact_'+contact.id">{{ contact.name }} ({{ contact.relationship }})</option>
                    </select>
                    <validation-feedback v-if="errors.recipient" :errors="errors.recipient" />
                </div>
            </div>

            <div class="mb-3 row">
                <label for="log_date" class="col-sm-3 col-form-label">Date/Time <span class="text-danger font-weight-bold">*</span></label>

                <div class="col-md-4">
                    <input type="date" class="form-control" v-model="formData.log_date">
                    <validation-feedback v-if="errors.log_date" :errors="errors.log_date" />
                </div>

                <div class="col-md-4">
                    <input type="time" class="form-control" v-model="formData.log_time">
                    <validation-feedback v-if="errors.log_time" :errors="errors.log_time" />
                </div>
            </div>

            <div class="mb-3 row">
                <label for="channel_id" class="col-sm-3 col-form-label">Channel<span class="text-danger font-weight-bold">*</span></label>

                <div class="col-md-9">
                    <select v-model="formData.channel_id" class="form-select" :disabled="loadingChannels">
                        <option v-if="loadingChannels" value="null">Loading channels...</option>
                        <option v-else value="null">Select...</option>
                        <option v-for="channel in channels" :value="channel.id">{{ channel.address }} ({{ channel.name }})</option>
                    </select>
                    <validation-feedback v-if="errors.channel_id" :errors="errors.channel_id" />
                </div>
            </div>

            <div class="mb-3 row">
                <label for="reason_id" class="col-sm-3 col-form-label">Subject<span class="text-danger font-weight-bold">*</span></label>

                <div class="col-md-9">
                    <select v-model="formData.reason_id" class="form-select">
                        <option value="null">Select...</option>
                        <option v-for="reason in reasons" :value="reason.id">{{ reason.name }}</option>
                    </select>
                    <validation-feedback v-if="errors.reason_id" :errors="errors.reason_id" />
                </div>
            </div>

            <div class="mb-3 row">
                <label for="status_id" class="col-sm-3 col-form-label">Status<span class="text-danger font-weight-bold">*</span></label>

                <div class="col-md-9">
                    <select v-model="formData.status_id" class="form-select">
                        <option value="null">Select...</option>
                        <option v-for="status in statuses" :value="status.id">{{ status.name }}</option>
                    </select>
                    <validation-feedback v-if="errors.status_id" :errors="errors.status_id" />
                </div>
            </div>

            <div class="mb-3 row">
                <label for="notes" class="col-sm-3 col-form-label">Notes<span class="text-danger font-weight-bold">*</span></label>

                <div class="col-md-9">
                    <textarea v-model="formData.notes" class="form-control"></textarea>
                    <validation-feedback v-if="errors.notes" :errors="errors.notes" />
                </div>
            </div>

		</div>
		<div class="modal-footer">
			<button class="btn btn-primary" @click="save">Save</button>
			<button class="btn btn-secondary" @click="closeForm">Cancel</button>
		</div>
	</modal-wrapper>
</template>

<script>
import { mapState } from 'vuex'
import { Modal } from 'bootstrap'
import ModalWrapper from '../shared/ModalWrapper.vue'
import ValidationFeedback from '../shared/ValidationFeedback'

export default {
	name: "CommLogForm",
	components: {
		ModalWrapper,
		ValidationFeedback
	},
	data() {
		return {
			modal: null,
			modalId: 'comm-log-form-modal',
			modalTitle: 'Add Communications Log',
			formData: {}
		}
	},
	methods: {
		closeForm() {
            this.$store.dispatch('communications/closeForm')
        },
		save() {
			this.$store.dispatch('communications/saveCommLog', this.formData)
		},
        getChannels() {
            if (this.formData.recipient.includes('contact_')) {
                this.$store.dispatch('communications/fetchContactChannels', this.formData.recipient)
            } else { 
                this.$store.dispatch('communications/fetchParticipantChannels')
            }
        },
		setFormData() {
            if (!_.isEmpty(this.log)) {
                this.formData = {
                    id: this.log.id,
                    log_date: this.log.log_date,
					log_time: this.log.log_time,
					channel_id: this.log.channel.id,
					reason_id: this.log.reason.id,
                    recipient: this.log.recipient_type == 'App\\Models\\Participant' ? 'participant_'+this.log.recipient.id : 'contact_'+this.log.recipient.id,
					status_id: this.log.status.id,
					notes: this.log.notes
                }
            } else {
                this.formData = {
                    id: '',
                    log_date: '',
                    log_time: '',
                    channel_id: '',
                    reason_id: '',
                    recipient: 'participant_'+this.participant.id,
                    status_id: '',
                    notes: ''
                }
            }
            this.getChannels()
    	}
	},
	computed: {
		...mapState({
            channels: state => state.communications.channels,
            contacts: state => state.communications.contacts,
            errors: state => state.communications.errors,
            formOpen: state => state.communications.formOpen,
            participant: state => state.communications.participant,
            loadingChannels: state => state.communications.loadingChannels,
            log: state => state.communications.logInForm,
            reasons: state => state.communications.reasons,
            statuses: state => state.communications.statuses,
        })
	},
	mounted() {
        this.modal = new Modal( document.getElementById('comm-log-form-modal') )
		this.$store.dispatch('communications/fetchCommunicationReasons')
		this.$store.dispatch('communications/fetchCommunicationStatuses')
        this.setFormData()
    },
    watch: {
        formOpen (newVal, oldVal) {
            this.setFormData()
            if (newVal) {
                this.modal.show()
            } else {
                this.modal.hide()
            }
        }
    }
}
</script>